import React from 'react';
import { Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const ProtectedRoute = ({ children, permission }) => {
  const userData = localStorage.getItem('user');

  if (!userData) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  const user = JSON.parse(userData);
  const userPermissions = user.permissions || [];
  const isAdmin = (user.role || '').toLowerCase() === 'admin';

  // If a permission is required, check if user has it or is an admin
  if (permission && !isAdmin) {
    const requiredPermissions = Array.isArray(permission) ? permission : [permission];
    const hasPermission = requiredPermissions.some(perm => userPermissions.includes(perm));

    if (!hasPermission) {
      // Notify the user they don't have access
      toast.error("You don't have permission to access this page.", {
        id: 'unauthorized-access', // Prevent duplicate toasts
      });
      console.log("you dont have permission", permission, "for this page", user, hasPermission, userData, requiredPermissions, isAdmin,)
      // Redirect to dashboard (or home)
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
